jQuery(document).ready(function(){
    let btnRes = jQuery('.search__it p');
    let divRes = jQuery('.search__tog');

    jQuery(btnRes).click(function() {
        console.log('test');
        let id = jQuery(this).data('result');
        let currentBtn = jQuery(this);
        let currentDiv = jQuery('.search__tog--' + id);
       
        currentBtn.addClass('js-res-open');
        currentDiv.addClass('js-res-open');

        // if (currentBtn.hasClass('js-res-open')) {
        //     currentBtn.removeClass('js-res-open');
        //     currentDiv.removeClass('js-res-open');
        // } else {
        //     jQuery(btnRes).removeClass('js-res-open');
        //     jQuery(divRes).removeClass('js-res-open');
        //     currentBtn.addClass('js-res-open');
        //     currentDiv.addClass('js-res-open');
        // }
    });
});